import React from 'react';

import type { AccountBalance } from '@eika-kortbetjening/types';

import { AccountService } from '@/domain/account';
import { AccountField, AmountField } from '@/domain/pay';
import { PayCardData } from '@/domain/pay/components/AccountField/types';
import useText from '@/hooks/use-text';

import ReceiverField from '@domain/pay/components/ReceiverField/ReceiverField';
import { CreditCard, CreditCardAccount } from '@generated-types';

import './TransferFormFields.scss';

type PaymentFormFields = {
    card: CreditCard;
    account: CreditCardAccount;
};

export const TransferFormFields = ({ card, account }: PaymentFormFields) => {
    const text = useText();

    const payCard: PayCardData = {
        id: card.id,
        number: card.cardNumber,
        productName: card.product.name,
        type: 'CREDIT',
    };

    const accountBalance: AccountBalance = AccountService.getBalance(account);

    return (
        <>
            <AmountField />
            <ul className="payment-form-fields__list">
                <li>
                    <AccountField
                        card={payCard}
                        accountBalance={accountBalance}
                        disabled={false}
                        id="transfer-select-from-account"
                        loadingError={false}
                        locked
                        onChange={() => {}}
                        setShowModal={() => {}}
                        showModal={false}
                        text={text}
                        cardList={[]}
                    />
                </li>
                <li>
                    <ReceiverField />
                </li>
            </ul>
        </>
    );
};
